import React from 'react'
import CollectionOfLinkBoxes from './CollectionOfLinkBoxes'

function SocialMediaArea() {
    const linkCollectionName = "Social Media";
    const linkCollectionDescription = "Follow me to find out whenever I publish a new blog post or make something:"
    const mySocialMediaAccounts = [{
        title: "Facebook",
        description: "Follow my Facebook page.",
        url: "https://www.facebook.com/georgewellr/"
    },{
        title: "Instagram",
        description: "Pictures of me and the things I make.",
        url: "https://www.instagram.com/theusernamegeorgewellerisnotav/"
    }];
    return (
        <div>
            <CollectionOfLinkBoxes linkCollectionDescription={linkCollectionDescription} linkCollectionName={linkCollectionName} links={mySocialMediaAccounts}></CollectionOfLinkBoxes>
        </div>
    )
}

export default SocialMediaArea
